export interface IHotListAnalyticsConfiguration {
  /**
   * Defaults to 1000
   */
  minimumBestListRevenueInEUR?: number;
  /**
   * Defaults to 1
   */
  amountOfHotLists?: number;
  /**
   * Defaults to undefined
   */
  lastNDaysToCalculateHot?: number;
  /**
   * Defaults to true.
   * If defined, it will overwrite lastNDaysToCalculateHot and show the comparison in current month
   */
  calculateHotInCurrentMonth?: boolean;
  /**
   * Defaults to true
   */
  showAlmostHotIcons?: boolean;
  /**
   * Defaults to 10
   */
  almostHotListPercentage: number;
}

export const baseHotListFeatureConfig = {
  minimumBestListRevenueInEUR: 1000,
  amountOfHotLists: 1,
  lastNDaysToCalculateHot: 14,
  calculateHotInCurrentMonth: true,
  showAlmostHotIcons: true,
  almostHotListPercentage: 10,
};

export function readHostListAnalyticsConfiguration(
  str?: string,
): Required<IHotListAnalyticsConfiguration> | undefined {
  if (!str) return undefined;

  try {
    return {
      ...baseHotListFeatureConfig,
      ...JSON.parse(str),
    };
  } catch (e) {
    return baseHotListFeatureConfig;
  }
}
